(() => {
const preference = matchMedia('(prefers-reduced-motion: reduce)');
function init(scope = document) {
  const form = scope.querySelector('#svc-book');
  if (form && !form.dataset.optionalReady) {
    form.dataset.optionalReady = 'true';
  }
  scope.querySelectorAll('.trial-cta').forEach(link => {
    if (link.dataset.anchorReady) return;
    link.dataset.anchorReady = 'true';
    link.addEventListener('click', event => {
      const target = document.getElementById('svc-book');
      if (!target) return;
      event.preventDefault();
      history.replaceState(null, '', '#svc-book');
      target.scrollIntoView({behavior: preference.matches ? 'instant' : 'smooth', block: 'start'});
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
    });
  });
  if (preference.matches || !window.IntersectionObserver || !Element.prototype.animate) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({isIntersecting, target}) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (!preference.matches) target.animate([{opacity:.65, transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}], {duration:500,easing:'cubic-bezier(.2,.7,.2,1)'});
    });
  }, {threshold:.12});
  scope.querySelectorAll('.service-composition .sf-tile').forEach(element => {
    if (element.dataset.revealReady) return;
    element.dataset.revealReady = 'true';
    observer.observe(element);
  });
}
preference.addEventListener('change', () => {
  if (preference.matches) document.getAnimations().forEach(animation => animation.cancel());
});
init();
document.addEventListener('shopify:section:load', event => init(event.target));
})();
